export class ViolationHeaderFooter
{
    id: number;
    organizationId: number;
    header: string;
    footer: string;
    isDefault: boolean;
    title: string;

    constructor(request: any) {
        this.id = request.id;
        this.organizationId = request.organizationId;
        this.header = request.header || null;
        this.footer = request.footer || null;
        this.isDefault = request.isDefault || false;
        this.title = request.footer ? request.footer : request.header;
    }
}
